import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Components/Header'
// teal #20c997
// dark light grey f7f9fa
import EmptyStar from '@mui/icons-material/StarBorderOutlined';
import FilledStar from '@mui/icons-material/Star';
import Collapsible from 'react-collapsible';
import MellaModel from '../../assets/mella-model.png'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import VerifiedIcon from '@mui/icons-material/Verified';
import PlayIcon from '@mui/icons-material/PlayCircleFilled';
import Thumb from '../../assets/thumb.jpg'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StairsIcon from '@mui/icons-material/Stairs';
import LanguageIcon from '@mui/icons-material/Language';
import VideoIcon from '@mui/icons-material/PersonalVideo';
import AssignmentIcon from '@mui/icons-material/ReceiptLong';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import DoneIcon from '@mui/icons-material/Done';
import BookIcon from '@mui/icons-material/MenuBook';
import PersonsIcon from '@mui/icons-material/PersonAdd';
import LockIcon from '@mui/icons-material/Lock';
import Footer from '../../Components/Footer';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import Player from '../../HulluWare/Player';
import { appContext } from '../../Context/appProvider';
import { api } from '../../api';
import humanizeDuration from "humanize-duration";
import { settingsContext } from '../../Context/settingsProvider';
import ReactHtmlParser from 'html-react-parser';


export const getHours = (sections = [], forSub=false) => {
    let total_sec
    if(forSub){
        total_sec = sections.reduce((ac, cu) => {
            return parseFloat(cu.duration || 0 ) + ac
        }, 0)
    } else total_sec = sections.reduce((sec_ac, sec_cu) => {
        let total = sec_cu.subsections.reduce((ac, cu) => {
            return parseFloat(cu.duration || 0 ) + ac
        }, 0)
        return total + sec_ac
    }, 0)


    return humanizeDuration(total_sec * 1000, {
        largest: 2, 
        round: true,
        spacer: " ", 
        units: ["h", "m"],
    });
    
    // let hours = Math.floor(total_sec / 3600).toString().padStart(2, '0');
    // (total_sec %= 3600).toString().padStart(2, '0');
    // let minutes = Math.floor(total_sec / 60).toString().padStart(2, '0');
    // let seconds = (total_sec % 60).toFixed(0).toString().padStart(2, '0');
    // return hours + ' : ' + minutes + ' : ' + seconds
}

export const getRating = (rates=[]) => {
    let length = rates.length
    if(!length) return 'No Rating'
    let total = rates.reduce((ac, cu) => ac + cu.rating?.value, 0)
    return (total / length).toFixed(1)
}


const RateStar = ({rate, small}) => (
    <div className='flex gap-1 items-center max-md:gap-0'>
        {Array(5).fill('').map((k, i) => (
            <div>
                {
                    (i + 1) <= rate ? (
                        <FilledStar style={{
                            color: '#d4af37',
                            fontSize: small ? 13 : 20
                        }}>Filled</FilledStar>
                    ) : (
                        <EmptyStar style={{
                            color: '#000000',
                            fontSize: small ? 13 : 20
                        }}>Filled</EmptyStar>
                    )
                }
            </div>
        ))}
    </div>
)

export default function CourseDetail() {
    const {id} = useParams()
    const [source, setSource] = useState({})
    const [totalHours, setTotalHours] = useState(0)
    const {token} = useContext(appContext)
    const [course, setCourse] = useState(null)
    const {t} = useContext(settingsContext)

    // const {isLoading, data} = useQuery('fetchCourse', () => 
    //     axios(baseUrl + path.getCourseDetail + '/' + id)
    // )
    // console.log(data)

    useEffect(() => {
        api.get(path.getCourseDetail + '/' + id).then(response => {
            let data = response.data
            if(data.success) setCourse(data.course)
        })
        window.scrollTo(0, 0);
    }, [])

    // const course = data?.data?.course

    useEffect(() => {
        if(course){
            console.log(course, '****((999')
            setSource({
                url: baseUrl + course.preview,
                type: 'application/x-mpegURL',
                previewThumbnail: course.previewThumbnail,
                thumbnail: course.thumbnail,
                values: course.languages
            })
            setTotalHours(getHours(course.sections))
        }
    }, [course])

    

    const getSectionLength = (sections =[]) => {
        let total = sections.reduce((ac, cu) => cu.subsections.length + ac, 0)
        return total
    }

  
  return (
    <div className='flex-1 w-full flex flex-col bg-lightGrey pt-[60px] overflow-y-auto overflow-x-hidden'>
         <div className='w-full flex flex-col'>
        <Header withLogo />
        <div className='flex flex-1 justify-between max-md:justify-start max-md:flex-col max-md:p-2 py-5 px-8 gap-10 max-md:gap-2'>
            <div className='flex flex-col gap-5 max-md:gap-2 max-w-2/3 w-2/3 max-md:w-full'>
                <div className='flex items-center gap-2'>
                    <p className='text-black font-bold text-[12px]'>{t('COURSES')}</p>
                    <ArrowForwardIosIcon style={{fontSize: 12, color: '#000000'}}>Filled</ArrowForwardIosIcon>
                    <p className='text-black text-[12px]'>{course?.subcategory?.name}</p>
                </div>
                {source.url && <div className='rounded-md overflow-hidden'><Player options={{source}} /></div>}
                {/* <div>
                    <iframe
                        title='preview'
                        src="https://customer-lys43q22v8za02zt.cloudflarestream.com/10f62de4c7cf06dcf57664114729ca5f/iframe?poster=https%3A%2F%2Fcustomer-lys43q22v8za02zt.cloudflarestream.com%2F10f62de4c7cf06dcf57664114729ca5f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                        loading="lazy"
                        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                        allowfullscreen="true"
                    ></iframe>
                </div> */}
                <div className='flex flex-col gap-3 max-md:self-center'>
                <div className='flex items-center gap-4 max-md:gap-2 max-md:flex-col'>
                    <div className='flex items-center gap-4'>
                        <div className='flex items-center gap-2'>
                            <AccessTimeIcon style={{color: '#000000', fontSize: 12}}>Filled</AccessTimeIcon>
                            <p className='text-black text-sm'>{getHours(course?.sections)}</p>
                        </div>

                        <div className='flex items-center gap-2'>
                            <StairsIcon style={{color: '#000000', fontSize: 12}}>Filled</StairsIcon>
                            <p className='text-black text-sm'>{t(course?.level?.toUpperCase())}</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <LanguageIcon style={{color: 'black', fontSize: 13}}>Filled</LanguageIcon>
                            <p className='text-black text-sm'>{course?.languages?.split(';')?.at(0)}</p>
                        </div>
                    </div>
                    <div className='flex items-center gap-4'>
                        <div className='flex items-center gap-2'>
                            <RateStar rate={getRating(course?.rates)}  />
                            <p className='text-sm max-md:text-xs'>({getRating(course?.rates)})</p>
                            <p className='text-sm max-md:text-xs'>| {course?.rates?.length} rates</p>
                        </div>
                        <div className='flex items-center gap-2'>
                            |
                            <PersonsIcon style={{color: '#000000', fontSize: 12}}>Filled</PersonsIcon>
                            <p className='text-black text-sm'>{course?.enrollCount || 0}</p>
                        </div>
                    </div>
                </div>

                </div>
                <h1 className='text-[35px] text-black font-bold max-md:text-[22px] text-center max-md:self-center'>{course?.title}</h1>
                {/* <p className='text-black font-bold text-[14px]'>Course By: <Link className='underline uppercase tracking-wider' to='/instructor/fuad'>{`${course?.instructor?.firstName} ${course?.instructor?.lastName}`}</Link></p> */}
                <hr className='text-[#00000050]' />
                <Link to={'/instructor/' + course?.instructor?.id} className='flex gap-2 items-center'>
                    <img className='w-[70px] h-[70px] rounded-full bg-[#e8e8e8] object-cover' src={baseUrl + course?.instructor?.image} />
                    <div className=''>
                        <div className='flex items-center gap-1'>
                            <p className='text-black font-bold text-[18px]'>{`${course?.instructor?.sellerprofile?.name || ''}`}</p>
                            <VerifiedIcon style={{color: '#52a4e0', fontSize: 20}}>Filled</VerifiedIcon>
                        </div>
                        <p className='mt-1 text-sm'>{(course?.instructor?.courseCount || 0) + ' ' + t('COURSES')}</p>
                    </div>
                </Link>
                <div className='bg-white shadow-md flex flex-col gap-3 max-md:gap-1 overflow-hidden rounded-md p-5'>
                    <p className='text-black text-[20px] font-bold'>{t('ABOUT_COURSE')}</p>
                    <div className='description p-2'>{ReactHtmlParser(course?.description || '')}</div>
                </div>
            </div>
            <div className='flex flex-col gap-10 w-full max-md:w-full max-md:gap-5'>
            <div className='h-fit bg-white shadow-md rounded-md flex flex-col p-3 gap-5'>
                <h1 className='text-black text-[27px] font-bold'>{t('ETB')} {course?.price?.toFixed(0)}</h1>
                <Link className='bg-main w-full text-white text-[20px] p-2 text-center' to={(!token ? '/login?next=/course/' : course?.enrollments?.length ? '/learn/' : '/checkout/') + course?.id}>{course?.isFree ? 'Get for Free' : course?.enrollments?.length ? t('START_LEARNING') : t('BUY_NOW')}</Link>
                <hr />
                <div className='flex flex-col gap-2'>
                    <div className='flex gap-2 items-center'>
                        <VideoIcon style={{color: '#000000', fontSize: 16}}>Filled</VideoIcon>
                        <p className='text-black text-sm'>{t('TOTAL_TIME')}: <span className='font-bold'>{totalHours}</span></p>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <BookIcon style={{color: '#000000', fontSize: 16}}>Filled</BookIcon>
                        <p className='text-black text-sm'>{getSectionLength(course?.sections)} {t('LESSONS')}</p>
                    </div>
                    {/* <div className='flex gap-2 items-center'>
                        <AssignmentIcon style={{color: '#000000', fontSize: 16}}>Filled</AssignmentIcon>
                        <p className='text-black text-sm'>Assignments</p>
                    </div> */}
                    <div className='flex gap-2 items-center'>
                        <BadgeIcon style={{color: '#000000', fontSize: 16}}>Filled</BadgeIcon>
                        <p className='text-black text-sm'>{t('CERTIFICATE')}</p>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <DoneIcon style={{color: '#000000', fontSize: 16}}>Filled</DoneIcon>
                        <p className='text-black text-sm'>{t('FREE_MATERIALS')}</p>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <DoneIcon style={{color: '#000000', fontSize: 16}}>Filled</DoneIcon>
                        <p className='text-black text-sm'>{t('LIFETIME_ACCESS')}</p>
                    </div>
                </div>
                
            </div>
            <div className='bg-white shadow-md flex flex-col gap-3 w-full overflow-hidden rounded-md p-3'>
                    <p className='text-black text-[20px] font-bold'>{t('COURSE_OUTLINE')}</p>
                    {course?.sections?.sort((a, b) => a.order - b.order)?.map(section => (
                        <Collapsible trigger={<div style={{backgroundColor: '#ebebeb', padding: 10, display: 'flex', 'justifyContent': 'space-between', 'alignItems': 'center'}}>
                            <p style={{userSelect: "none", color: 'black', fontSize: 15}}>{section.name}</p>
                            <span><ArrowDownIcon>Filled</ArrowDownIcon></span>
                            </div>} transitionTime={200}>
                                {
                                    section.subsections?.sort((a, b) => a.order - b.order)?.map(sub => (
                                        <div style={{
                                            display: 'flex',
                                            gap: 10,
                                            alignItems: 'center',
                                            padding: 10
                                        }}>
                                            <LockIcon style={{color: '#000000', fontSize: 15}}>Filled</LockIcon>
                                            <p style={{color: '#000000', fontSize: 14}}>{sub.name}</p>
                                        </div>
                                    ))
                                }
                               
                            
                        </Collapsible>
                    ))}
                    
                </div>
                <div className='bg-white shadow-md flex flex-col gap-3 w-full overflow-hidden rounded-md p-3'>
                    <div className='flex items-center gap-2'>
                        <p className='text-black text-[20px] font-bold'>Rates </p>
                        | <RateStar rate={getRating(course?.rates)}  />
                        <p className='text-sm'>({getRating(course?.rates)})</p>
                        <p className='text-sm'>| {course?.rates?.length} rates</p>
                    </div>
                    {course?.rates?.slice(0, 8)?.map(rate => (
                        <div className='flex flex-col gap-2'>
                            <div className='flex items-cener gap-2'>
                                <div className='bg-[#00000040] w-[40px] h-[40px] rounded-full flex items-center justify-center'>
                                    <PersonIcon>Filled</PersonIcon>
                                </div>
                                <div>
                                    <h3>{rate.firstName}</h3>
                                    <RateStar rate={rate.rating?.value} small />
                                </div>
                            </div>
                            <p className='text-xs border-l-[1px] border-l-[#00000070] pl-2'>{rate.rating.comment}</p>
                        </div>
                    ))}
                    
                </div>
                </div>
           
        </div>   
        </div>
        
        <Footer />
    </div>

   
  )
}